import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { IconButton, TextField } from "@mui/material";
import { snack } from "components/toast";

interface TextFieldWithCopyProps {
  value: string;
  label: string;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  error?: boolean;
  helperText?: any;
  inputProps?: any;
}

function TextFieldWithCopy(props: TextFieldWithCopyProps) {
  const { label, value, name, onChange, onBlur, disabled = false, required, error, helperText, inputProps } = props;

  const onCopy = () => {
    window.navigator.clipboard.writeText(value).then(
      function () {
        navigator.clipboard.readText().then(() => {
          snack.success(`${label} Copied`);
        });
      },
      function (err) {
        snack.error("something went wrong");
      }
    );
  };

  return (
    <TextField
      label={label}
      fullWidth
      variant="outlined"
      size="small"
      onBlur={onBlur}
      value={value}
      disabled={disabled}
      required={required}
      name={name}
      onChange={onChange}
      InputProps={{
        endAdornment: (
          <IconButton onClick={onCopy}>
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        ),
        inputProps,
      }}
      InputLabelProps={{ shrink: true }}
      helperText={helperText}
      error={error}
    />
  );
}

export default TextFieldWithCopy;
